<template>
  <div class="animated fadeIn">
    <b-row v-if="loading">
      <b-col md="6">
        <atom-spinner
          :animation-duration="1000"
          :size="60"
          color="#ff1d5e"
          class="float-right my-4"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-card
          border-variant="info"
    
        >
          <div slot="header">
            <span data-font="20">FAQS</span>
            <div class="card-header-actions"></div>
          </div>
          <div v-if="faqs && faqs.length > 0">
            <div
              role="tablist"
              v-for="(item, index) in faqs"
              :key="item.id"
              class="box"
            >
              <b-card no-body class="mb-1">
                <b-card-header
                  header-tag="header"
                  class="p-1 accord_head"
                  role="tab"
                >
                  <div block v-b-toggle="'accordion' + item.item_id">
                    <b-col
                      @click="toggleItem(index)"
                      v-bind:href="'#collapse' + index"
                    >
                      <span style="color: black">{{ item.Topic }}</span>

                      <i
                        :class="[isActive(index) ? 'fa-minus' : 'fa-plus']"
                        class="more-less fa float-right"
                      ></i>
                    </b-col>
                  </div>
                </b-card-header>
                <b-collapse
                  :id="'accordion' + item.item_id"
                  accordion="my-accordion"
                  role="tabpanel"
                  style
                >
                  <b-row>
                    <b-col>
                      <b-card-body>{{ item.Description }}</b-card-body>
                    </b-col>
                    <b-col>
                      <b-card-body v-if="item.mediaType === 'IMAGE'">
                        <img
                          v-bind:src="item.mediaContent"
                          style="height: 200px; width: 450px"
                        />
                      </b-card-body>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </div>
          </div>
          <div class="text-center" v-else>
            <div>No data available!</div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cTable from "../base/Table.vue";
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import TenantVue from "../tenant/Tenant.vue";

export default {
  name: "ViewItem",
  components: {
    cTable,
    AtomSpinner,
  },
  data() {
    return {
      faq: {},
      toggled: [],
      loading:false,
    };
  },
  computed: {
    faqs() {
      let data = this.$store.getters["faq/GetFaqList"];
      let faqList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          for (let i = 0; i < obj.items.length; i++) {
            let arrayObj = {
              _id: obj._id,
              category: obj.category,
              Topic: obj.items[i].topic,
              Description: obj.items[i].description,
              mediaType: obj.items[i].media.mediaType,
              mediaContent: obj.items[i].media.mediaContent,
              item_id: obj.items[i]._id,
              flag: false,
              ...obj,
            };
            faqList.push(arrayObj);
          }
        });
        return faqList;
      } else {
        this.loading = false;
        return [];
      }
    },
  },
  methods: {
    isActive(item) {
      return this.toggled.indexOf(item) >= 0;
    },
    toggleItem(item) {
      const index = this.toggled.indexOf(item);
      if (index >= 0) {
        this.toggled.splice(index, 1);
        return;
      }

      this.toggled.push(item);
    },
  },
  async mounted() {
    this.loading=true;
    let dataObj;
    if (JSON.parse(sessionStorage.getItem("userLogin"))["role"] === "Tenant") {
      dataObj = {
        scope: "TENANT",
      };
    } else {
      dataObj = {
        scope: "PARTNER",
      };
    }
    await this.$store.dispatch("faq/fetchFaqs", dataObj).then((data) => {
      if (data.message) {
        this.$toasted.error(data.message);
      } else {
      }
    });
    this.loading=false;
  },
};
</script>

<style scoped>
[data-font="20"] {
  font-size: 20px;
}
.more-less {
  margin-top: 6px;
}
.accord_head {
  padding: 14px 4px !important;
}
</style>
